/** The internal organization that platform (SaaS operator) administrators sign in to. Never billed. */
export const PLATFORM_TENANT_ID = "tenant_platform";
